import React from "react";

import { Tooltip } from "./tooltip.component";

type Props = {
    title?: string;
    innerHTML: string;
};

const TooltipContainer = ({ innerHTML, title }: Props) => {
    return <Tooltip innerHTML={innerHTML} title={title} />;
};

export { TooltipContainer };
